<template>
  <div class="page-main">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">{{this.$route.params.namespace}}</li>
      </ol>
      <h1 class="page-title">{{ $t('team.labels.setting') }}</h1>
    </div>
    <div class="page-content">
      <div class="panel">
        <div class="panel-body panel-form">
          <loading-indicator v-if="isLoading"></loading-indicator>
          <form v-else v-on:submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-6 col-xs-12">
                <h3 class="card-title">
                  {{ $t('team.labels.rename') }}
                </h3>
                <alert v-show="showAlert"
                  alertClass="m-b-25 alert-dismissible"
                  v-bind:type="`${ (successResponse) ? 'success' : 'danger' }`"
                  v-bind:iconClass="`${ (successResponse) ? 'md-check' : 'md-close' }`">
                  <span v-if="successResponse">{{successResponse}}</span>
                  <span v-else-if="errorResponse">{{errorResponse}}</span>
                </alert>
                <div class="form-section">
                  <form-group v-bind:error="formErrors.first('name')">
                    <label for="team">{{ $t('team.displayName.labels') }}</label>
                    <span  class="guideline-block">{{ $t('team.displayName.textGuide') }}</span>
                    <input type="text" class="form-control input-lg" id="name" placeholder="Team Display name" v-model="team.name">
                  </form-group>
                  <form-group>
                    <label for="name">{{ $t('team.url.labels') }}</label>
                    <span class="help-block m-t-0">{{ $t('team.url.textGuide') }}</span>
                    <div class="input-group">
                      <div class="input-group-addon">{{`${baseURL}/`}}</div>
                      <input type="text" class="form-control input-lg" id="namespace" placeholder="Team URL" v-model="team.namespace" disabled="true">
                    </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <button type="submit" class="btn btn-success" :disabled="isSubmiting" v-bind:class="{ 'btn-default': isSubmiting }">
                  <div class="loader vertical-align-middle loader-circle loader-form" v-if="isSubmiting"></div> {{ $t('team.action.submit') }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Validator } from 'vee-validate';
import FormGroup from 'components/forms/FormGroup';
import Alert from 'components/Alert';
import LoadingIndicator from 'components/LoadingIndicator';

export default {
  components: {
    FormGroup,
    Alert,
    LoadingIndicator,
  },
  watch: {
    'team.name': function() {
      if (this.formErrors.has('name')) {
        this.formErrors.remove('name');
      }
    },
  },
  computed: {
    baseURL: () => process.env.BASE_URL,
  },
  data: function () {
    return {
      isSubmiting: false,
      isLoading: false,
      showAlert: false,
      validator: null,
      formErrors: null,
      errorResponse: null,
      successResponse: null,
      team: null,
    };
  },
  created: function() {
    this.isLoading = true;
    this.validator = new Validator();
    this.validator.attach('name', 'required|max:72', { prettyName: 'Team Display name' });

    this.$set(this, 'formErrors', this.validator.errorBag);
  },
  mounted: function() {
    this.fetchTeam();
  },
  methods: {
    onSubmit: function () {
      // hide alert
      this.showAlert = false;

      this.validator.validateAll({
        name: this.team.name,
      })
      .then((success) => {
        if (!success) {
          return;
        }

        const namespace = this.$route.params.namespace;

        this.isSubmiting = true;
        axios.put(`/api/teams/${namespace}`, {
          name: this.team.name,
        })
        .then((response) => {
          this.isSubmiting = false;
          this.successResponse = this.$t('team.response.success');
          this.errorResponse = null;
          this.team = response.data;
          this.showAlert = true;

          this.$store.dispatch('updateCurrentUserTeam', this.team);
        })
        .catch((error) => {
          this.isSubmiting = false;

          if (error.response.status === 422) {
            this.errorResponse = this.$t('team.response.failed');
            this.formErrors.addAll(error.response.data);
          } else {
            this.errorResponse = this.$t('team.response.defaultFailed');
          }
          this.showAlert = true;
        });
      })
      .catch(() => {
        this.isSubmiting = false;
      });
    },
    fetchTeam: function() {
      const namespace = this.$route.params.namespace;

      axios.get(`/api/teams/${namespace}`)
      .then((response) => {
        this.team = response.data;
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
        // error
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// TeamSetting.vue?58e6ccf6